export default () => {
    let header = document.querySelector('.main-header');

    if(document.querySelector('.main-about')) {
        header.setAttribute('style', 'background-color: transparent;');
    } else {
        header.removeAttribute('style');
    }
}